import { forwardRef } from 'react';
import Input, { InputProps } from '@mui/material/Input';
import InputAdornment from "@mui/material/InputAdornment";
import PhoneIcon from "@mui/icons-material/Phone";


type CustomPhoneInputProps = Omit<InputProps, 'name' | 'label'>;

const CustomPhoneInput = forwardRef<HTMLInputElement, CustomPhoneInputProps>(function CustomPhoneInput(
  props,
  ref,
) {
  return (
    <Input
      {...props}
      inputRef={ref}
      fullWidth
      size="small"
      placeholder="Phone number"
      name="phone"
      startAdornment={
        <InputAdornment position="start">
          <PhoneIcon color="primary" />
        </InputAdornment>
      }      
    />
  );
});

export default CustomPhoneInput;

